import { TowingRecordRouteType } from '../../../../common/types'

interface RouteWithIndex {
  type: TowingRecordRouteType
}

export function getIndexOfRoute(routes: RouteWithIndex[], routeType: TowingRecordRouteType): number {
  return routes.findIndex(route => route.type === routeType)
}
